import * as Scrivito from "scrivito";
import moment from "moment";
import { getHomepage } from "./getHomepage";

export const getPresentObjSearch = () => {
  const currentDate = moment().startOf("day").toDate();
  return Scrivito.Obj.all()
    .andNot("publishFrom", "isGreaterThan", currentDate)
    .andNot("publishUntil", "isLessThan", currentDate);
};

export const getObjSearchWithHomepage = () => {
  const homepage = getHomepage();
  if (!homepage) return null;
  return getPresentObjSearch().and("_path", "startsWith", homepage.path());
};

export interface FilterItem {
  key?: string;
  name?: string;
  class?: string[];
  serieId?: number;
  parentName?: string;
  parentCategories?: string[];
  isSerie?: boolean;
}

export const filterByNameOrKey = (extraParam: string) => (item: FilterItem) => {
  const search = extraParam.toLowerCase();

  if (item.name && item.name.toLowerCase().includes(search)) {
    return true;
  }
  if (item.key && item.key.toLowerCase().includes(search)) {
    return true;
  }
  if (
    Array.isArray(item.parentCategories) &&
    item.parentCategories.some(
      (cat) => typeof cat === "string" && cat.toLowerCase().includes(search),
    )
  ) {
    return true;
  }
  return false;
};
